import * as React from 'react'
import { Button, Form } from 'react-bootstrap'

// パートナーログインフォームのパラメータ
const loginPartnerPrams = {
  action: `/general/login/partner`,
  loginNameParam: `login_name`,
  passwordNameParam: `password`,
  reminderLink: `/general/partner/reminder/`,
}

// markup
const GlobalHeaderLoginFormPartner = (): React.JSX.Element => {
  return (
    <>
      <Form
        action={loginPartnerPrams.action}
        method="post"
        data-e2e-test="loginFormPartner"
        data-testid="loginFormPartner"
      >
        <div className="row m-0">
          <small className="p-0 m-0 fw-bold">パートナー会員</small>
          <div className="col-md p-0">
            <Form.Group controlId="formPartnerId">
              <Form.Control
                className="globalHeaderMobileNavigation__loginInput"
                type="text"
                name={loginPartnerPrams.loginNameParam}
                placeholder="ログインID"
                data-e2e-test="formPartnerId"
              />
            </Form.Group>
          </div>

          <div className="col-md p-0 globalHeader-mediaQuery-ml-1">
            <Form.Group controlId="formPartnerPassword">
              <Form.Control
                className="globalHeaderMobileNavigation__loginInput"
                name={loginPartnerPrams.passwordNameParam}
                type="password"
                placeholder="パスワード"
                data-e2e-test="formPartnerPassword"
                autoComplete="true"
              />
            </Form.Group>
          </div>

          <div className="col-md p-0 globalHeader-mediaQuery-ml-1">
            <Button
              variant="partner"
              type="submit"
              className="w-100 globalHeader__loginButton"
              data-e2e-test="formPartnerSubmit"
            >
              ログイン
            </Button>
          </div>
        </div>

        <div className="textLink globalHeader-mediaQuery-mobile-text-end">
          <a className="textLink__link" href="/general/partner/reminder/">
            パスワードを忘れた方はこちら
          </a>
        </div>
      </Form>
    </>
  )
}

export default GlobalHeaderLoginFormPartner
